type Domain = string;
type Value = number;
export type ValueMap = Map<Value, Set<Domain>>;

export const addToValueMap = ({ map, value, domain }: { map: ValueMap; value: Value; domain: Domain }) => {
    const domains = map.get(value);

    if (domains) {
        domains.add(domain);
        return;
    }

    map.set(value, new Set([domain]));
};

export const getLeadersFromMap = (map: ValueMap): Set<Domain> => {
    const maxValue = map.size > 0 ? Math.max(...map.keys()) : 0;

    return maxValue > 0 ? (map.get(maxValue) ?? new Set()) : new Set();
};
